import type { MenuItem } from 'primeng/api';

export const QUOTE_REQUESTS_LINK = 'billing/quote-requests';

/** «Solicitudes (3)»: Sakai's menu draws no PrimeNG `badge` (and `libs/sakai-ng/` is not
 *  ours to change), so the count of unattended requests rides in the label. */
export function quoteRequestsLabel(unattended: number | null): string {
  return unattended ? `Solicitudes (${String(unattended)})` : 'Solicitudes';
}

export function withQuoteRequestsLabel(menu: MenuItem[], label: string): MenuItem[] {
  return menu.map((section) => ({
    ...section,
    items: section.items?.map((item) =>
      (item.routerLink as string[] | undefined)?.[0] === QUOTE_REQUESTS_LINK ? { ...item, label } : item,
    ),
  }));
}
